"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AllowedHubs = {
  HUBS_CAMPAIGN: 'HUBS_CAMPAIGN',
  HUBS_CONTENT: 'HUBS_CONTENT',
  HUBS_CTA: 'HUBS_CTA',
  HUBS_MEDIUM: 'HUBS_MEDIUM',
  HUBS_SIGNUP_URL: 'HUBS_SIGNUP_URL',
  HUBS_SOURCE: 'HUBS_SOURCE'
};
var _default = AllowedHubs;
exports.default = _default;
module.exports = exports.default;